import { EmbedLayout } from '@/components/EmbedLayout';
import { StandaloneLayout } from '@/components/StandaloneLayout';
import { isEmbedded } from '@/domain/embed';
import { useStationFinder } from '@/hooks/useStationFinder';

/* One flow, two surfaces. The standalone page is what sales sends over WhatsApp; the
   embed is the same page inside the vammo.com home, where the section it replaces is
   horizontal and already carries its own heading. Only the layout differs — the lookup,
   the bands and the lead capture are the hook's, once. */
export const App = () => {
  const finder = useStationFinder();

  return isEmbedded(window.location.search) ? (
    <EmbedLayout {...finder} />
  ) : (
    <StandaloneLayout {...finder} />
  );
};
